import type { FunctionComponent, ReactNode } from 'react';
import React from 'react';

import { GameWing } from '@pp/core/src/components/game/gameWing/GameWing';
import { DirectionProps } from '@pp/core/src/components/game/gameWingItem/GameWingItem';
import { L10nText } from '@pp/core/src/services/uiTranslations/reactBindings/L10nText';
import { Trophy } from '@pp/core/src/store/slices/promotionsV2/types';

import { GameWingItem } from '../gameWingItem/GameWingItem';

export interface TotalBetWingProps {
  totalBet: ReactNode;
  trophy?: Trophy;
  netPosition?: string | ReactNode;
  lastWin?: number | null;
}

export const TotalBetWing: FunctionComponent<TotalBetWingProps> = ({ totalBet, trophy, netPosition, lastWin }) => {
  return (
    <GameWing direction={DirectionProps.end}>
      {netPosition && (
        <GameWingItem dataType="net-position" label={<L10nText tk="NET_POSITION" />} value={netPosition} />
      )}
      <GameWingItem
        dataType="total-bet"
        direction={DirectionProps.end}
        trophy={trophy}
        label={lastWin ? <L10nText tk="LASTWIN" /> : <L10nText tk="BET" />}
        value={totalBet}
        lastWin={lastWin}
      />
    </GameWing>
  );
};
